import { DataListModel } from '../data';
import { MoveSkuLineModel } from './move-line';
export interface MoveLineListModel extends DataListModel {
  results: MoveSkuLineModel[];
}
